// 招待の受諾画面（portal.md「招待の受諾」/ registration.md R3）。
// 受諾リンクを送るのは SSO の招待だけ（パスワードの招待はメールのリンクからログインへ直接進む。ADR-0019）。
// パスワードと判定されたリンク（方式の変更前に発行されたもの）には、招待メールでのログインを案内する。

import { useEffect, useState } from "react";
import { api, messageFor } from "../lib/api";
import { signIn } from "../lib/auth";

type Info = Awaited<ReturnType<typeof api.invitation>>;

export function InvitePage() {
  const token = new URLSearchParams(window.location.search).get("token") ?? "";
  const [info, setInfo] = useState<Info | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api.invitation(token).then(setInfo).catch((e) => setError(messageFor(e)));
  }, [token]);

  if (error) return <main className="narrow"><h1>招待</h1><p className="error">{error}</p></main>;
  if (!info) return <main className="narrow"><p className="muted">読み込み中…</p></main>;

  return (
    <main className="narrow">
      <h1>{info.contractName} に招待されています</h1>
      <p>{info.email} <span className="muted">（期限 {info.expiresAt.slice(0, 10)}）</span></p>
      {info.method === "sso" ? (
        <>
          <p className="muted">組織のアカウント（SSO）でログインします。</p>
          <p><button className="primary" onClick={() => signIn(info.email, { invitedContractId: info.contractId })}>SSO でログイン</button></p>
        </>
      ) : (
        <>
          <p className="muted">
            メールアドレスとパスワードでログインします。仮パスワードは招待メールに記載されています。
            見当たらない場合は、招待した管理者に再送を依頼してください。
          </p>
          <p><button className="primary" onClick={() => signIn(info.email, { invitedContractId: info.contractId })}>ログインへ</button></p>
        </>
      )}
    </main>
  );
}
